<template>
    <div>
        <v-row class="mb-0" style="position: relative">
            <v-col>
                <v-select hide-details solo label="Første række" v-model="firstRow" :items="filteredRows['firstRow']" class="mb-2" />
                <v-select hide-details solo label="Anden række" v-model="secondRow" :items="filteredRows['secondRow']" />
                <v-btn class="switch-rows-button white--text" fab small @click="switchRows" color="third">
                    <v-icon size="medium">
                        fa-sync-alt
                    </v-icon>
                </v-btn>            
            </v-col>                        
            <v-col>
                <range-picker :solo="true" storeName="meetings" rangeName="range" periodName="period" :presets="$store.state.meetings.meetingDatePresets" />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <loader v-if="loading" />
                    <sales-pivot v-else
                        defaultSort="avgClosed"
                        :dataObject="stats"
                        :fields="fields"
                        :nestedFields="nestedFields"
                        :valueFunctions="valueFunctions" />
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import SalesPivot from '@/components/salesPivot.vue'
import RangePicker from '@/components/rangePicker.vue'

export default {
    components: {
        SalesPivot,
        RangePicker
    },
    data () {
        return {
            firstRow: 'MeetingBookingAgent.name',
            secondRow: 'MeetingSalesAgent.name',
            rows: [
                {
                    text: 'Bookingagent',
                    value: 'MeetingBookingAgent.name'
                },
                {
                    text: 'Agentur',
                    value: 'MeetingSalesAgent.name'
                },
                {
                    text: 'Kampagne',
                    value: 'campaign.name'
                }
            ],
            loading: true,
            stats: null,
            fields: [
                {
                    header: 'Total',
                    field: 'allMeetingsCount',
                    cols: '1',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Åbne',
                    field: 'openMeetingsCount',
                    cols: '1',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Gnf.',
                    field: 'completedCount',
                    cols: '1',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Reklm.',
                    field: 'complaintCount',
                    cols: '1',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Afls.',
                    field: 'canceledCount',
                    cols: '1',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Afls.%',
                    field: 'cancelrate',
                    cols: '1',
                    formatter: this.$options.filters.percentage
                },
                {
                    header: 'Salg',
                    field: 'salesCount',
                    cols: '1',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Hitrate',
                    field: 'hitrate',
                    cols: '1',
                    formatter: this.$options.filters.percentage
                },
                {
                    header: 'Præmie',
                    field: 'value',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'PpB',
                    field: 'avgClosed',
                    cols: '2',
                    formatter: this.$options.filters.separator
                }
            ],
            valueFunctions: {
                'allMeetingsCount': v => v.allMeetingsCount,
                'openMeetingsCount': v => v.openMeetingsCount,
                'completedCount': v => v.completedCount,
                'complaintCount': v => v.complaintCount,
                'canceledCount': v => v.canceledCount,
                'salesCount': v => v.salesCount,
                'value': v => v.value,
                'hitrate': v => (v.completedCount + v.canceledCount) ? v.salesCount / (v.completedCount + v.canceledCount) : !!v.salesCount * 1,
                'cancelrate': v => (v.completedCount + v.complaintCount + v.canceledCount) ? v.canceledCount / (v.completedCount + v.complaintCount + v.canceledCount) : 0,
                'avgClosed': v => v.closedCount ? v.value / v.closedCount : v.value
            },
            nestedFields: ['allMeetingsCount', 'openMeetingsCount', 'completedCount', 'complaintCount', 'canceledCount', 'closedCount', 'salesCount', 'value']
        }
    },
    computed: {
        filteredRows () {
            return {
                firstRow: this.rows.filter(row => row.value !== this.secondRow),
                secondRow : this.rows.filter(row => row.value !== this.firstRow),
            }
        },
        range () {
            return this.$store.state.meetings.range
        },
        period () {
            return this.$store.state.meetings.period
        }
    },
    methods: {
        async getData() {
            this.loading = true
            const response = await this.$http().get('booking/stats/pivot', {
                params: {
                    firstKey: this.firstRow,
                    secondKey: this.secondRow,
                    from: this.range[0],
                    to: this.range[1]
                }
            })
            this.stats = response.data
            this.loading = false
        },
        switchRows () {
            const tempFirstRow = this.firstRow
            this.firstRow = this.secondRow
            this.secondRow = tempFirstRow
        }
    },
    watch: {
        firstRow: function () {
            this.getData()
        },
        secondRow: function () {
            this.getData()
        },
		range: {
			handler({ length }) {
                if (length === 2) this.getData();
			},
			deep: true
        },
        period: function () {
		    this.$store.commit("meetings/setRange", { range: 'range', preset: this.$store.state.meetings.period });
        }
    },
    created () {
        this.getData()
    }
}
</script>

<style lang="scss">
.switch-rows-button {
    position: absolute;
    left: -20px;
    top: 44px;
}
</style>